

<script>

/**
 * Reporting component
 */
export default {
 
  props:{
    selectedcampaign:{
      type: Object,
      default:() => null
    }

  },

};
</script>


<template>
    
       <!-- state Order -->
       <div v-if="selectedcampaign" class ="col-12 mt-4 d-print-none">
          <div class="card h-100 " style="border:1px solid #ddd;">
              <div class="card-body card bg-Defaul p-3">

                <h4 class="text-dark text-uppercase font-weight-bold">{{ $t('campaign.history.historyTitle') }}</h4>

       
                  <div class="hori-timeline">
                    
                    <ul class="list-inline events" >

                       <!-- new -->
                       <li class="list-inline-item event-list" >
                        <div class="mt-3">
                          <div class="px-2" :class="selectedcampaign.supervisoryAssistanceDate != null && selectedcampaign.beingPrintDate == null  &&  selectedcampaign.finishedPrintDate == null  && selectedcampaign.beingDistributedDate == null  && selectedcampaign.deliveredDate == null ?  'font-weight-bold text-primary' :'text-dark font-size-14'">
                            <p class="mb-0 font-weight-bold font-size-14">{{selectedcampaign.supervisoryAssistanceDate ? selectedcampaign.supervisoryAssistanceDate : '-'}} </p>
                          </div>


                          <div class="event-up-icon mt-4">
                            <img 
                              alt="" 
                              width="35px"  
                              class="bg-white arrow-icon" 
                              :src="require('@/assets/icons/' + (
                                (selectedcampaign.supervisoryAssistanceDate != null && 
                                selectedcampaign.beingPrintDate == null  &&  
                                selectedcampaign.finishedPrintDate == null  && 
                                selectedcampaign.beingDistributedDate == null  && 
                                selectedcampaign.deliveredDate == null) 
                                ? 'arrow-circle-up-p.svg' 
                                : 'Arrow_circle_up_solid.svg'
                              ))"   
                              :class="{
                                'bounce-animation': selectedcampaign.supervisoryAssistanceDate != null && 
                                                    selectedcampaign.beingPrintDate == null  &&  
                                                    selectedcampaign.finishedPrintDate == null  && 
                                                    selectedcampaign.beingDistributedDate == null  && 
                                                    selectedcampaign.deliveredDate == null
                              }"
                            />
                      
                            </div>
                          <div class="event-date mt-4" :class="selectedcampaign.supervisoryAssistanceDate != null && selectedcampaign.beingPrintDate == null  &&  selectedcampaign.finishedPrintDate == null  && selectedcampaign.beingDistributedDate == null  && selectedcampaign.deliveredDate == null ?  'font-weight-bold text-primary' :'text-dark font-size-14'">
                            <span>{{$t("campaign.history.timeline.supervisoryAssistance")}}</span>
                          </div>
                        </div>
                      </li>


                       <!-- Order submission -->
                       <li class="list-inline-item event-list" >
                        <div class="mt-3">
                          <div class="px-3" :class="selectedcampaign.beingPrintDate != null && selectedcampaign.finishedPrintDate == null  && selectedcampaign.beingDistributedDate == null  && selectedcampaign.deliveredDate == null   ?  'font-weight-bold text-primary' :'text-dark font-size-14'">
                            <p class="mb-0 font-weight-bold font-size-14">{{selectedcampaign.beingPrintDate ? selectedcampaign.beingPrintDate : '-'}} </p>
                          </div>

                          <div class="event-up-icon mt-4">
                            <img 
                              alt="" 
                              width="35px"  
                              class="bg-white arrow-icon" 
                              :src="require('@/assets/icons/' + (
                                selectedcampaign.beingPrintDate != null && 
                                selectedcampaign.finishedPrintDate == null && 
                                selectedcampaign.beingDistributedDate == null && 
                                selectedcampaign.deliveredDate == null 
                                  ? 'arrow-circle-up-p.svg' 
                                  : 'Arrow_circle_up_solid.svg'
                              ))"   
                              :class="{
                                'bounce-animation': selectedcampaign.beingPrintDate != null && 
                                                    selectedcampaign.finishedPrintDate == null && 
                                                    selectedcampaign.beingDistributedDate == null && 
                                                    selectedcampaign.deliveredDate == null
                              }"
                            />
                   
                          </div>
                          <div class="event-date mt-4" :class="selectedcampaign.beingPrintDate != null && selectedcampaign.finishedPrintDate == null  && selectedcampaign.beingDistributedDate == null  && selectedcampaign.deliveredDate == null   ?  'font-weight-bold text-primary' :'text-dark font-size-14'">
                            <span>{{$t("campaign.history.timeline.startPrintDate")}}</span>
                          </div>
                        </div>
                      </li>


                      <!-- Customer Confirmed -->

                      <li class="list-inline-item event-list">
                        <div class="mt-3">
                          <div class="px-3" :class="selectedcampaign.finishedPrintDate != null && selectedcampaign.beingDistributedDate == null  && selectedcampaign.deliveredDate == null   ?  'text-primary' :'text-dark '">
                            <p class="mb-0 font-weight-bold font-size-14">{{selectedcampaign.finishedPrintDate ? selectedcampaign.finishedPrintDate : '-'}}</p>
                          </div>


                          <div class="event-up-icon mt-4">
                            <img 
                              alt="" 
                              width="35px"  
                              class="bg-white arrow-icon" 
                              :src="require('@/assets/icons/' + (
                                selectedcampaign.finishedPrintDate != null && 
                                selectedcampaign.beingDistributedDate == null && 
                                selectedcampaign.deliveredDate == null 
                                  ? 'arrow-circle-up-p.svg' 
                                  : 'Arrow_circle_up_solid.svg'
                              ))"   
                              :class="{
                                'bounce-animation': selectedcampaign.finishedPrintDate != null && 
                                                    selectedcampaign.beingDistributedDate == null && 
                                                    selectedcampaign.deliveredDate == null
                              }"
                            />

                          </div>
                          <div class="event-date mt-4" :class="selectedcampaign.finishedPrintDate != null && selectedcampaign.beingDistributedDate == null  && selectedcampaign.deliveredDate == null   ?  'font-weight-bold text-primary' :'text-dark font-size-14'">
                            <span>{{$t("campaign.history.timeline.endPrintDate")}}</span>
                          </div>
                        </div>
                      </li>

                        <!-- being prepared -->
                        <!-- <li class="list-inline-item event-list" >
                        <div class="mt-3">
                          <div class="px-3" :class="selectedcampaign.beingDistributedDate != null && selectedcampaign.deliveredDate == null  ?  'text-primary' :'text-dark'">
                            <p class="mb-0 font-weight-bold font-size-14">{{selectedcampaign.beingDistributedDate ? selectedcampaign.beingDistributedDate : '-'}}</p>
                          </div>

                          <div class="event-up-icon mt-4">
                            <img 
                              alt="" 
                              width="35px"  
                              class="bg-white arrow-icon" 
                              :src="require('@/assets/icons/' + (
                                selectedcampaign.beingDistributedDate != null && selectedcampaign.deliveredDate == null 
                                  ? 'arrow-circle-up-p.svg' 
                                  : 'Arrow_circle_up_solid.svg'
                              ))"   
                              :class="{
                                'bounce-animation': selectedcampaign.beingDistributedDate != null && selectedcampaign.deliveredDate == null
                              }"
                            />


                          </div>
                          <div class="event-date mt-4" :class="selectedcampaign.beingDistributedDate != null && selectedcampaign.deliveredDate == null  ?  'font-weight-bold text-primary' :'text-dark font-size-14'">
                            <span >{{$t("campaign.history.timeline.beingDistributedDate")}}</span>
                          </div>
                        </div>
                      </li> -->

                     

                      <!-- started -->
                      <li class="list-inline-item event-list" >
                        <div class="mt-3">
                          <div class="px-3" :class="selectedcampaign.finishedDate == null &&  selectedcampaign.deliveredDate != null  ?  'text-primary' :'text-dark'">
                            <p class="font-weight-bold font-size-14 mb-0" :class="selectedcampaign.finishedDate == null &&  selectedcampaign.deliveredDate != null  ?  'text-primary' :'text-dark'">{{selectedcampaign.deliveredDate ? selectedcampaign.deliveredDate : '-'}}</p>
                          </div>

                          <div class="event-up-icon mt-4">
                            <img 
                              alt="" 
                              width="35px"  
                              class="bg-white arrow-icon" 
                              :src="require('@/assets/icons/' + (
                               selectedcampaign.finishedDate == null &&  selectedcampaign.deliveredDate != null 
                                  ? 'arrow-circle-up-p.svg' 
                                  : 'Arrow_circle_up_solid.svg'
                              ))"   
                              :class="{
                                'bounce-animation': selectedcampaign.finishedDate == null && selectedcampaign.deliveredDate != null
                              }"
                            />                          </div>
                          <div class="event-date mt-4" :class="selectedcampaign.finishedDate == null &&  selectedcampaign.deliveredDate != null  ?  'font-weight-bold text-primary' :'text-dark font-size-14'">
                            <span >{{$t("campaign.history.timeline.startDateCampaign")}}</span>
                          </div>
                        </div>
                      </li>

                      <!-- finished -->
                      <li class="list-inline-item event-list" >
                        <div class="mt-3">
                          <div class="px-3" :class="selectedcampaign.finishedDate != null  ?  'text-primary' :'text-dark'">
                            <p class="font-weight-bold text-primary font-size-14 mb-0">{{selectedcampaign.finishedDate ? selectedcampaign.finishedDate : '-'}}</p>
                          </div>

                          <div class="event-up-icon mt-4">
                            <img 
                              alt="" 
                              width="35px"  
                              class="bg-white arrow-icon" 
                              :src="require('@/assets/icons/' + (
                                selectedcampaign.finishedDate != null 
                                  ? 'arrow-circle-up-p.svg' 
                                  : 'Arrow_circle_up_solid.svg'
                              ))"   
                              :class="{
                                'bounce-animation': selectedcampaign.finishedDate != null
                              }"
                            />                          </div>
                          <div class="event-date mt-4" :class="selectedcampaign.finishedDate != null  ?  'font-weight-bold text-primary' :'text-dark font-size-14'">
                            <span >{{$t("campaign.history.timeline.endDateCampaign")}}</span>
                          </div>
                        </div>
                      </li>

            

                    </ul>

                  </div>


                 
              </div>
          </div>
      </div>
</template>
<style scoped>
.event-up-icon img{
  transform: scale(1);
  transition: transform 0.65s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.arrow-icon {
  transition: transform 1s ease, opacity 1s ease;
}

.event-up-icon:hover .arrow-icon {
  transform: translateY(-20px);
  opacity: 0.2;
}

</style>


<style>
    .list-inline.events {
        display: flex;
        flex-wrap: wrap; 
    }

    .list-inline-item.event-list {
        flex: 1 0 100%; 
        margin: 5px;
    }

    @media (min-width: 1200px) {
        .list-inline-item.event-list {
            max-width: calc(20.00% - 10px);
        }
    }

    @media (min-width: 992px) and (max-width: 1199px) {
        .list-inline-item.event-list {
            max-width: calc(33.33% - 10px); 
        }
    }

    @media (min-width: 576px) and (max-width: 991px) {
        .list-inline-item.event-list {
            max-width: calc(33.33% - 10px); 
        }
    }

    @media (max-width: 575px) {
        .list-inline-item.event-list {
            max-width: calc(100% - 10px);
        }
    }

    @keyframes bounce-up-down {
      0%, 100% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(-20px);
      }
    }

    .bounce-animation {
      animation: bounce-up-down 1.5s infinite ease-in-out;
    }

</style>